/**
 * @fileoverview Barrel exports for the style-guardrails-generator-v2 agent.
 *
 * This module provides a co-located agent following the agent-per-folder pattern:
 * - definition.ts: Agent metadata and configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Handlebars prompt template
 * - flow.ts: Genkit flow implementation
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
  type HookInput,
  type TemplateRef,
} from './schema';

// Flow
export { flow } from './flow';

// Prompt template
export { prompt } from './prompt';
